/**
 * 브랜드와 캠페인 협업하기(시딩) — 29CM Snowplow 이벤트 data 빌더.
 *
 * 협업하기 시딩 영역은 29CM Snowplow 정의서(#5)만 완전 커버한다. 무신사(AMP/GA4)는
 * 시딩 전용 카드/필터 시트가 없어 보류(기존 coupon-era Amplitude 탭 발화는 유지) — hand-off.
 * 카드 노출/클릭이 동일 payload 를 공유하므로 data 빌더로 중앙화한다(키 parity 유지).
 */

const PAGE_COLLABORATE = 'curator_collaborate_brand_campaign';
const SECTION_COLLABORATE_LIST = 'CuratorCollaborateCampaignList';

/** 협업 캠페인 목록 노출/클릭 공용 data. 🚩 brand_no 미제공(리스트 item DTO에 없음) → 생략. */
export function buildCollaborateCampaignSnowplowData(params: {
  campaignId: number;
  /** item.searchStatus (PENDING/CONFIRMED/COMPLETED/NOT_SELECTED|REJECTED) */
  stageStatus: string;
  /** 리스트 내 0-based map index */
  index: number;
  /** curatorId = userInfo.snsTitle. 29CM Snowplow layout_id 슬롯. 빈값이면 '' */
  curatorId?: string;
}) {
  return {
    page_name: PAGE_COLLABORATE,
    section_name: SECTION_COLLABORATE_LIST,
    section_title: SECTION_COLLABORATE_LIST,
    on_site_content_id: params.campaignId,
    stage_status: params.stageStatus,
    format_type: 'seeding',
    position: params.index + 1,
    layout_id: params.curatorId ?? '',
  };
}

/**
 * 협업 필터 클릭 (모집유형/상태/타입) 공용 data. depth↔UI 매핑은 잠정 — hand-off 확인 대상.
 * - buttonId: curator_recruitment_type_filter | curator_campaign_status_filter | curator_campaign_status_filter2
 */
export function buildCollaborateFilterSnowplowData(params: {
  buttonId: string;
  buttonName: string;
  /** curatorId = userInfo.snsTitle. 29CM Snowplow layout_id 슬롯. 빈값이면 '' */
  curatorId?: string;
}) {
  return {
    page_name: PAGE_COLLABORATE,
    section_name: 'CuratorCollaborateBrandFilter',
    section_title: 'CuratorCollaborateBrandFilter',
    button_id: params.buttonId,
    button_name: params.buttonName,
    position: -1,
    layout_id: params.curatorId ?? '',
  };
}
